module.exports = __webpack_public_path__ + "img/4.aaac9210.png";